module.exports = __webpack_public_path__ + "img/no-product.33b044f1.png";